// aus yoocon importiert & angepasst für nutsandwoods

import $ from 'jquery';
import Watcher from './watcher';
import {isPhone, isIOS, isSafari} from './useragent';

const watcher = new Watcher();
const is_IOS = isIOS();
const is_safari = isSafari();

class AutoplayVideo {
    private isVideoLoaded: boolean = false; // Flag to track if the video has been loaded
    private isPlaying: boolean = false; // Flag to track if the video is currently playing
    private playTimeout: number | undefined; // Timeout ID for debouncing play

    constructor($ele: JQuery, $triggerEle?: JQuery) {
        const $video = $ele as JQuery<HTMLVideoElement>;

        // Check if the video element exists and is of correct type
        if (!$video.length || !$video[0] || typeof $video[0].play !== 'function') {
            console.error("Invalid video element:", $ele);
            return;
        }

        const video = $video[0] as HTMLVideoElement;
        video.removeAttribute('autoplay');

        const device = isPhone ? 'phone' : 'desktop';

        const setPoster = () => {
            $video.children('source').each((index, ele) => {
                const sourceDevice = ele.getAttribute('data-device');
                if (sourceDevice && sourceDevice != device) return;

                // const sourceLocale = ele.getAttribute('data-locale');
                // if(sourceLocale && sourceLocale != locale) return;

                // const src = ele.getAttribute('data-src');
                // if(!src) return;
                // $video.attr('src', src);
                const poster = ele.getAttribute('data-poster');
                if(poster)
                    $video.attr('poster', poster);
                return false;
            });
        }
        // setPoster(); //NOTE: ist bisher nicht für die Verwendung in nutsandwoods angepasst

        // Load the correct video based on screen size
        const loadVideo = () => {
            if (!this.isVideoLoaded) {

                $video.children('source').each((index, ele) => {
                    const sourceDevice = ele.getAttribute('data-device');
                    if (sourceDevice && sourceDevice != device) return;

                    // const sourceLocale = ele.getAttribute('data-locale');
                    // if(sourceLocale && sourceLocale != locale) return;

                    const src = ele.getAttribute('data-src');
                    if(!src) return;

                    $(ele).attr('src', src);
                });

                video.load(); // Load the video
                this.isVideoLoaded = true;
            }
        };

        const loadVideoBasedOnNetwork = () => {
            const connection = (navigator as any).connection || {};
            const effectiveType = connection.effectiveType || '4g'; // Default to '4g' if undefined

            let quality = 'high';
            if (['2g', '3g'].includes(effectiveType)) {
                quality = 'low'; // Low quality for slow networks
            }

            // Load appropriate video source
            $video.children('source').each((index, ele) => {
                const sourceQuality = ele.getAttribute('data-quality');
                if (sourceQuality && sourceQuality !== quality) return;

                const src = ele.getAttribute('data-src');
                if (!src) return;
                $(ele).attr('src', src);
            });

            video.load(); // Load the video
            this.isVideoLoaded = true;
        };

        // Play the video after debouncing
        const playVideo = (direction: number) => {
            if (this.playTimeout) {
                clearTimeout(this.playTimeout); // Clear existing timeout if present
            }

            this.playTimeout = window.setTimeout(() => {
                this.playTimeout = undefined;
                if (!this.isPlaying) {
                    if (direction === 1) video.currentTime = 0; // Reset video time if scrolling down
                    // Only attempt to play if video is muted (required by iOS)
                    if (video.muted || is_IOS || is_safari) {
                        video.play().then(() => {
                            this.isPlaying = true;
                            $video.addClass('playing');
                        }).catch(err => {
                            console.error("Error playing video:", err);
                        });
                    } else {
                        console.warn("Autoplay blocked: Ensure video is muted for iOS/Safari.");
                    }
                }
            }, 10); // Adjust debounce time as needed
        };

        // Pause the video (no debounce needed)
        const pauseVideo = (direction: number) => {
            if (this.playTimeout) {
                clearTimeout(this.playTimeout); // Clear any existing timeout
                this.playTimeout = undefined;
            }

            if (this.isPlaying) {
                video.pause();
                this.isPlaying = false;
                $video.removeClass('playing');

                if (direction === -1) {
                    video.currentTime = 0; // Reset video time if scrolling up
                }
            }
        };

        const triggerElement = ($triggerEle && $triggerEle.length > 0) ? $triggerEle[0] : video;

        const thisVideo = this;
        watcher.add({
            element: triggerElement,
            onAppearing(element, direction) {
                // loadVideo(); // Load video immediately when it appears  //NOTE: ist bisher nicht für die Verwendung in nutsandwoods angepasst
                // if (!thisVideo.isVideoLoaded) loadVideoBasedOnNetwork(); //NOTE: dafür im ejs source für low quality einfügen
                playVideo(direction);
            },
            onDisappeared(element, direction) {
                pauseVideo(direction);
            },
        });
    }
}

export default AutoplayVideo;
